// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-iNI1Y","button":"button-TA6F2","count":"count-2AaVz"};